import React from "react";
import { CheckCircle } from "@mui/icons-material";

import { NavigationButtonProps } from "ui";

import { StackedNavigationButton } from "fond/widgets";

const RefinementButton: React.FC<Omit<NavigationButtonProps, "iconSize" | "rightElement" | "sx">> = ({ checked, ...props }) => (
  <StackedNavigationButton
    iconSize="small"
    sx={{ m: 0, mt: 0.5 }}
    checked={checked}
    rightElement={checked ? <CheckCircle color="success" sx={{ fontSize: 18 }} /> : undefined}
    {...props}
  />
);

export default RefinementButton;
